module.exports = __webpack_public_path__ + "static/media/nutritional-counter-app-composition2.74a19229.jpg";